<div class="container">
  <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-plane-arrival"></i></span>{{ 'Menu.Menu.ImportDeclaration' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.ImportDeclarationNum' | translate }}</label>
              <p-chips formControlName="importDeclarationNo" [(ngModel)]="searchParams.importDeclarationNo" separator=","
                (onAdd)="chipsAdd($event, 'importDeclarationNo')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.ReceiptFormNum' | translate }}</label>
              <p-chips formControlName="whNo" [(ngModel)]="searchParams.whNo" separator=","
                (onAdd)="chipsAdd($event, 'whNo')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.TradeTerm' | translate }}</label>
              <div class="item">
                <p-multiSelect formControlName="incoTerm"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.incoTerm"
                  [options]="incoTermOptions" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.Forwarder' | translate }}</label>
              <div class="item">
                <p-multiSelect formControlName="forwarder"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.forwarder"
                  [options]="forwarderList" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.Supplier' | translate }}</label>
              <div class="item">
                <p-dropdown formControlName="vendor"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.vendor"
                  [options]="vendorList" [filter]="true" (onFilter)="getVendorList($event)" ></p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.ExportCountryCode' | translate }}</label>
              <div class="item">
                <p-multiSelect formControlName="exportCountryCode"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.exportCountryCode"
                  [options]="exportCountryCodeList" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.DeclarationType' | translate }}</label>
              <div class="item">
                <p-multiSelect formControlName="docType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.docType"
                  [options]="docTypeList" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.IdentificaitonNum' | translate }}</label>
              <p-chips formControlName="docNo" [(ngModel)]="searchParams.docNo" separator=","
                (onAdd)="chipsAdd($event, 'docNo')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.CaseNum' | translate }}</label>
              <p-chips formControlName="applyNo" [(ngModel)]="searchParams.applyNo" separator=","
                (onAdd)="chipsAdd($event, 'applyNo')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar" >
              <laas-calendar
                #declarationDate
                [title]="'ImportDeclaration.Search.DeclarationDate'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event,'declarationDate')">
              </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ImportDeclaration.Search.CustomsDeclarationMethod' | translate }}</div>
              <div class="item">
                <p-multiSelect formControlName="importType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.importType"
                  [options]="importTypeList" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ImportDeclaration.Search.Brand' | translate }}</div>
              <p-chips formControlName="brand" [(ngModel)]="searchParams.brand" separator=","
                (onAdd)="chipsAdd($event, 'brand')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.HAWB' | translate }}</label>
              <p-chips formControlName="expressBill" [(ngModel)]="searchParams.expressBill" separator=","
                (onAdd)="chipsAdd($event, 'expressBill')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.MAWB' | translate }}</label>
              <p-chips formControlName="mawbNo" [(ngModel)]="searchParams.mawbNo" separator=","
                (onAdd)="chipsAdd($event, 'mawbNo')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.ReceiptNum' | translate }}</label>
              <p-chips formControlName="trxNumber" [(ngModel)]="searchParams.trxNumber" separator=","
                (onAdd)="chipsAdd($event, 'trxNumber')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ImportDeclaration.Search.Company' | translate }}</div>
              <div class="item">
                <p-multiSelect formControlName="orgId"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.orgId"
                  [options]="orgIdList" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <div class="mb-1">{{ 'ImportDeclaration.Search.Status' | translate }}</div>
              <div class="item">
                <p-multiSelect formControlName="status"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [(ngModel)]="searchParams.status"
                  [options]="statusList" [filter]="true" filterBy="label,value"></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-4 laas-calendar" >
              <laas-calendar
                #creationDate
                [title]="'ImportDeclaration.Search.CreationTime'"
                [enableMaxDateIsToday]="false"
                [showRangeMode]="true"
                [showStartMode]="true"
                (onDateChange)="dateOnChange($event,'creationDate')">
              </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.Creataor' | translate }}</label>
              <p-chips formControlName="createUser" [(ngModel)]="searchParams.createUser" separator=","
                (onAdd)="chipsAdd($event, 'createUser')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.LastUpdateBy' | translate }}</label>
              <p-chips formControlName="updateUser" [(ngModel)]="searchParams.updateUser" separator=","
                (onAdd)="chipsAdd($event, 'updateUser')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'ImportDeclaration.Search.Facility' | translate }}</label>
                <laas-facility-dropdown
                  formControlName="facilityList"
                  [isMultiple]="true"
                  [showClear]="false"
                  [showFilter]="true"
                  [defaultSelectFirst]="true"
                  [showToggleAll]="true"
                  (onOptionDataChange)="optionsDataOnChange($event, 'facilityList')"
                >
                </laas-facility-dropdown>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn($event)" class="p-button-secondary ml-2"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table
        [expandable]="true"
        (rowExpanded)="searchDetailClick($event)"
        [tableKey]="preferenceKey"
        [selectable]="true"
        [(selectedRows)]="selectedImportRows"
        [dataKey]="'importDeclarationNo'"
        [value]="importRows"
        [defaultColumns]="columns"
        [loading]="isLoading"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [lazy]="true">
        <ng-template pTemplate="caption">
          <div class="col">
            <button pButton pRipple icon="far fa-file-excel" [disabled]="selectedImportRows.length === 0" (click)="exportExcel($event)" class="p-button-success ml-4"></button>
          </div>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'importDeclarationNo'">
                  <div class="overflow-text">
                    <a href="javascript: void(0);" (click)="importDeclarationNoLinkClick($event, rowData)">{{rowData[col.field]}}</a>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'orgId'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:orgIdList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'status'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:statusList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'incoTerm'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:incoTermList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'forwarder'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:forwarderList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'vendor'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:vendorOptions | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'exportCountryCode'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:exportCountryCodeList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'docType'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:docTypeList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'currency'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:currencyList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'exportCityCode'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:cityList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'importType'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:importTypeList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'whStatus'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | optionsMapping:whStatusList | replaceNullWith:'-'}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div [ngSwitch]="col.dataType">
                        <ng-container *ngSwitchCase="'date'">
                          <div class="overflow-text">
                            {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <div class="overflow-text">
                            {{ rowData[col.field] | replaceNullWith:'-'}}
                          </div>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>
        </td>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
          <laas-data-table [tableTitle]="formatTableTitle(rowData)" [tableKey]="preferenceKey2" [dataKey]="'seqNo'"
            [selectable]="false" [(selectedRows)]="rowData.seqNo" [value]="rowData.importDetails"
            [defaultColumns]="detailColumns" [paginator]="false" [style]="{ 'overflow-y': 'auto' }">

            <ng-template pTemplate="caption">
              <button class="ml-3" pButton pRipple (click)="openImportDetailDeclarationModal($event, rowData)" label="{{ 'ImportDeclaration.Button.Import' | translate }}"></button>
              <button class="ml-3" pButton pRipple (click)="openBillingViewerBtn($event, rowData)" label="{{ 'ImportDeclaration.Button.CostReview' | translate }}"></button>
              <button class="ml-3" (click)="openBillingFeeBtn($event, rowData)" pButton pRipple label="{{ 'ImportDeclaration.Button.BillingFee' | translate }}"></button>
              <button class="ml-3" pButton pRipple (click)="openCopyImportDeclarationModal($event, rowData)" label="{{ 'ImportDeclaration.Button.CopyImport' | translate }}"></button>
              <button class="ml-3" pButton pRipple (click)="confirmImportDeclarationBtnClick($event, rowData)" label="{{ 'ImportDeclaration.Button.ImportConfirm' | translate }}"></button>
              <button class="ml-3" pButton pRipple (click)="cancelImportDeclarationBtnClick($event, rowData)" label="{{ 'ImportDeclaration.Button.ImportCancel' | translate }}"></button>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                  <div [ngSwitch]="col.field">
                    <ng-container *ngSwitchCase="'__delete'">
                      <span *ngIf="rowData['status'] == 'A'" class="icon" (click)="deleteBtnClick($event, rowIndex, rowData)"><i class="fas fa-trash-alt"></i></span>
                    </ng-container>
                    <ng-container *ngSwitchCase="'sourceType'">
                      <div class="overflow-text">
                        {{ rowData[col.field] | optionsMapping:sourceTypeList | replaceNullWith:'-'}}
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'status'">
                      <div class="overflow-text">
                        {{ rowData[col.field] | optionsMapping:statusList | replaceNullWith:'-'}}
                      </div>
                    </ng-container>
                      <ng-container *ngSwitchDefault>
                          <ng-container [ngSwitch]="col.dataType">
                              <ng-container *ngSwitchCase="'date'">
                                <div class="overflow-text">
                                  {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                </div>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <div class="overflow-text">
                                  {{ rowData[col.field] | replaceNullWith:'-'}}
                                </div>
                              </ng-container>
                          </ng-container>
                      </ng-container>
                      <ng-template #displayEmpty>
                          -
                      </ng-template>
                  </div>
              </td>
            </ng-template>
            <ng-template pTemplate="footer" let-columns="columns">
              <tr>
                <td *ngFor="let col of columns; let i = index">
                  <div [ngSwitch]="col.field">
                    <ng-container *ngSwitchCase="'trxAmount'">
                      {{getTotalAmount(rowData).trxAmount | number:"1.2" | replaceNullWith:'-'}}
                    </ng-container>
                    <ng-container *ngSwitchCase="'importAccTdAmt'">
                      {{getTotalAmount(rowData).importAccTdAmt | number:"1.2" | replaceNullWith:'-'}}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <ng-container *ngIf="i == 0">
                        {{ 'ImportDeclaration.SubTable.Total' | translate }}
                      </ng-container>
                    </ng-container>
                    <ng-template #displayEmpty>
                      -
                    </ng-template>
                  </div>
                </td>
              </tr>
            </ng-template>
          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>

  <p-dialog header="{{ 'ImportDeclarationCopy.Header' | translate }}" appendTo="body" [(visible)]="isShowCopyImportModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">
    <form [formGroup]="copyForm">
      <div class="p-fluid formgrid grid">
        <div class="field col-12">
          <label>{{ 'ImportDeclarationCopy.AWBNum' | translate }}</label>
          <input pInputText type="text" formControlName="expressBill" [(ngModel)]="copyParams.expressBill" [class]="(copySubmitted && f(copyForm).expressBill.errors) ? ['ng-invalid', 'ng-dirty'] : []" />
          <small *ngIf="copySubmitted && f(copyForm).expressBill.errors" class="errors">
            <div *ngIf="f(copyForm).expressBill.errors.required" class="p-invalid">{{ 'ImportDeclarationCopy.AWBNum' | translate }} is required</div>
          </small>
        </div>
        <div class="field col-12">
          <label>{{ 'ImportDeclarationCopy.CustomsDeclarationAnt' | translate }}</label>
          <p-inputNumber formControlName="importAmount"
              mode="decimal" [minFractionDigits]="2" [(ngModel)]="copyParams.importAmount" styleClass="text-right"></p-inputNumber>
        </div>
        <div class="field col-12">
          <label>{{ 'ImportDeclarationCopy.IdentificaitonNum' | translate }}</label>
          <div>
            <input maxlength="2" type="text" style="width:18%;" pInputText [(ngModel)]="copyParams.docNo1" formControlName="docNo1" /> /
            <input maxlength="2" type="text" style="width:18%;" pInputText [(ngModel)]="copyParams.docNo2" formControlName="docNo2" /> /
            <input maxlength="2" type="text" style="width:18%;" pInputText [(ngModel)]="copyParams.docNo3" formControlName="docNo3" /> /
            <input maxlength="4" type="text" style="width:18%;" pInputText [(ngModel)]="copyParams.docNo4" formControlName="docNo4" /> /
            <input maxlength="5" type="text" style="width:18%;" pInputText [(ngModel)]="copyParams.docNo5" formControlName="docNo5" />
          </div>
          <small *ngIf="(f(copyForm).docNo1.errors || f(copyForm).docNo2.errors || f(copyForm).docNo3.errors || f(copyForm).docNo4.errors || f(copyForm).docNo5.errors)" class="errors">
            <div *ngIf="f(copyForm).docNo1.errors?.fullWidth || f(copyForm).docNo2.errors?.fullWidth || f(copyForm).docNo3.errors?.fullWidth || f(copyForm).docNo4.errors?.fullWidth || f(copyForm).docNo5.errors?.fullWidth" class="p-invalid">請輸入半形字符</div>
          </small>
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <button pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}" (click)="copyImportBtnClick($event)"></button>
          <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" class="p-button-secondary ml-2"></button>
        </div>
      </div>
    </form>
  </p-dialog>
  <p-dialog header="{{ 'ImportDeclaration.Button.Import' | translate }}" appendTo="body" [(visible)]="isShowImportModal" [modal]="true" [draggable]="false" [resizable]="false" [style]="{ width: '50%' }">
    <form [formGroup]="importForm">
      <div *ngIf="isLoadingImportDetail" class="loadingMask">
          <p-progressSpinner></p-progressSpinner>
      </div>
      <div class="p-fluid formgrid grid">

        <div class="field col-12">
          <label>{{ 'ImportDeclarationImport.DocumentSource' | translate }}</label>
          <p-dropdown appendTo="body" (onChange)="changeSourceType($event)" formControlName="sourceType" [filter]="true" [options]="sourceTypeList" [(ngModel)]="importDetailParams.sourceType" [class]="(importSubmitted && f(importForm).sourceType.errors) ? ['ng-invalid', 'ng-dirty'] : []" placeholder="{{ 'Common.Message.ChooseOption' | translate}}"></p-dropdown>
          <small *ngIf="importSubmitted && f(importForm).sourceType.errors" class="errors">
            <div *ngIf="f(importForm).sourceType.errors.required" class="p-invalid">{{ 'ImportDeclarationImport.DocumentSource' | translate }} is required</div>
          </small>
        </div>
        <div class="field col-12">
          <label>{{ 'ImportDeclarationImport.TrxNumber' | translate }}</label>
          <p-chips formControlName="trxNumber" separator="," (onAdd)="onTrxNumberAdd($event)" (onRemove)="onTrxNumberRemove()" [class]="(importSubmitted && f(importForm).sourceType.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-chips>
          <small *ngIf="importSubmitted && f(importForm).trxNumber.errors" class="errors">
            <div *ngIf="f(importForm).trxNumber.errors.required" class="p-invalid">{{ 'ImportDeclarationImport.TrxNumber' | translate }} is required</div>
          </small>
        </div>
        <div  *ngIf="displayADImportWidget('trxDtTmp')" class="field col-12">
          <label>{{ 'ImportDeclarationImport.DocumentDate' | translate }}</label>
          <p-calendar appendTo="body" formControlName="trxDtTmp" [(ngModel)]="importDetailParams.trxDtTmp" dateFormat="yy/mm/dd" [class]="(importSubmitted && f(importForm).trxDtTmp.errors) ? ['ng-invalid', 'ng-dirty'] : []">
          </p-calendar>
          <small *ngIf="importSubmitted && f(importForm).trxDtTmp.errors" class="errors">
            <div *ngIf="f(importForm).trxDtTmp.errors.required" class="p-invalid">{{ 'ImportDeclarationImport.DocumentDate' | translate }} is required</div>
          </small>
        </div>
        <div *ngIf="displayADImportWidget('trxAmount')" class="field col-12">
          <label>{{ 'ImportDeclarationImport.AccountingAnt' | translate }}</label>
          <p-inputNumber formControlName="trxAmount"
              mode="decimal" [minFractionDigits]="2" [(ngModel)]="importDetailParams.trxAmount" styleClass="text-right" [class]="(importSubmitted && f(importForm).trxAmount.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-inputNumber>
          <small *ngIf="importSubmitted && f(importForm).trxAmount.errors" class="errors">
            <div *ngIf="f(importForm).trxAmount.errors.required" class="p-invalid">{{ 'ImportDeclarationImport.AccountingAnt' | translate }} is required</div>
          </small>
        </div>
        <div *ngIf="displayADImportWidget('pcsrDept')" class="field col-12">
          <label>{{ 'ImportDeclarationImport.PCSRDept' | translate }}</label>
          <input pInputText type="text" formControlName="pcsrDept" [(ngModel)]="importDetailParams.pcsrDept" />
        </div>
        <div *ngIf="displayADImportWidget('brand')" class="field col-12">
          <label>{{ 'ImportDeclarationImport.Brand' | translate }}</label>
          <p-dropdown appendTo="body" formControlName="brand" [filter]="true" [options]="brandList" [(ngModel)]="importDetailParams.brand" [class]="(importSubmitted && f(importForm).brand.errors) ? ['ng-invalid', 'ng-dirty'] : []"></p-dropdown>
          <small *ngIf="importSubmitted && f(importForm).brand.errors" class="errors">
            <div *ngIf="f(importForm).brand.errors.required" class="p-invalid">{{ 'ImportDeclarationImport.Brand' | translate }} is required</div>
          </small>
        </div>
      </div>
      <div class="grid">
        <div class="col">
          <button [disabled]="importForm.invalid ||isLoadingImportDetail" pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}" (click)="importDetailBtnClick($event)"></button>
          <button pButton pRipple label="{{ 'Common.Button.Cancel' | translate }}" (click)="closeImportDetailModal($event)" class="p-button-secondary ml-2"></button>
        </div>
      </div>
    </form>
  </p-dialog>

  <laas-billing-viewer [display]="isShowBillingViewerModal" [bookingNo]="bookingNoFile" [bookingInfo]="bookingInfo" [feature]="'IN-DECLARATION'" (onClose)="closeBilling($event)"></laas-billing-viewer>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
